





















import { Component, Vue } from "vue-property-decorator";
import ScrollMagic from 'scrollmagic'; 

@Component({})
export default class HomeSection extends Vue {
  controller: any = null;

  mounted() {
    var isVertical = Vue.prototype.common.isVerticalLayout();
    if (isVertical) {
      // do not animate home section on vertical layout
      document.getElementById("home-section-container").classList.add("animate");
      document.getElementById("home-section-container").classList.add("animated");
    } else {
      this.controller = new ScrollMagic.Controller({
        vertical: false
      });
      const splashScene = new ScrollMagic.Scene({
          triggerElement: "#home-section-container",
          triggerHook: 0.5,
          reverse: false // only do once
        })
        .on("enter", this.splashScreen)
        .addTo(this.controller);
    }
  }
  
  splashScreen() {
    setTimeout(function() {
      var elem = document.getElementById("home-section-container");
      if (elem) {
        (<HTMLElement> elem)!.classList.add("animate");

        // after 5 seconds (animation delay limit), add animated class to override any transition effects
        setTimeout(function() { 
          (<HTMLElement> elem)!.classList.add("animated");
        }, 5000);
      }
    }, 1000);
  }

  beforeDestroy() {
    this.controller.destroy(true);
    this.controller = null;
  }
}
